export default __webpack_public_path__ + "images/1be7f792fb7d089cb8c4cf555ceb68a8-andy-greeting.es.png";